import { produce } from 'immer'

export const SET_LOADING = 'voiceAgentsAnalytics/setLoading'
export const SET_ERROR = 'voiceAgentsAnalytics/setError'
export const SET_SUMMARY = 'voiceAgentsAnalytics/setSummary'
export const SET_CALL_VOLUME = 'voiceAgentsAnalytics/setCallVolume'
export const SET_BY_AGENT = 'voiceAgentsAnalytics/setByAgent'
export const SET_RECENT_CALLS = 'voiceAgentsAnalytics/setRecentCalls'
export const SET_ACTIVE_CALLS = 'voiceAgentsAnalytics/setActiveCalls'
export const SET_ACTIVE_CALLS_STATUS = 'voiceAgentsAnalytics/setActiveCallsStatus'

// SSE connection health, surfaced on the tile: green when CONNECTED, grey (with
// a hover) while CONNECTING or once DISCONNECTED (retries exhausted).
export const ACTIVE_CALLS_STATUS = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
}

export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setError = (payload) => ({ type: SET_ERROR, payload })
export const setSummary = (payload) => ({ type: SET_SUMMARY, payload })
export const setCallVolume = (payload) => ({ type: SET_CALL_VOLUME, payload })
export const setByAgent = (payload) => ({ type: SET_BY_AGENT, payload })
export const setRecentCalls = (payload) => ({ type: SET_RECENT_CALLS, payload })
export const setActiveCalls = (payload) => ({ type: SET_ACTIVE_CALLS, payload })
export const setActiveCallsStatus = (payload) => ({ type: SET_ACTIVE_CALLS_STATUS, payload })

export const initialState = {
  summary: null,
  callVolume: [],
  byAgent: [],
  recentCalls: { items: [], total: 0 },

  // Live per-agent counts from the SSE stream — BE sends every agent unfiltered,
  // the FE sums those in the current filter. Live, not windowed by the date range.
  activeCalls: {
    items: [],
    totalActiveCalls: 0,
    orgId: null,
    status: ACTIVE_CALLS_STATUS.CONNECTING,
  },

  loading: {
    summary: false,
    callVolume: false,
    byAgent: false,
    recentCalls: false,
  },
  error: {
    summary: null,
    callVolume: null,
    byAgent: null,
    recentCalls: null,
  },
}

export default function voiceAgentsAnalyticsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_ERROR:
        newState.error = { ...newState.error, ...payload }
        break
      case SET_SUMMARY:
        newState.summary = payload
        break
      case SET_CALL_VOLUME:
        newState.callVolume = Array.isArray(payload) ? payload : []
        break
      case SET_BY_AGENT:
        newState.byAgent = Array.isArray(payload) ? payload : []
        break
      case SET_RECENT_CALLS:
        newState.recentCalls = {
          items: Array.isArray(payload?.items) ? payload.items : [],
          total: payload?.total || 0,
        }
        break
      case SET_ACTIVE_CALLS:
        // Preserve `status` — it's owned by SET_ACTIVE_CALLS_STATUS.
        newState.activeCalls.items = Array.isArray(payload?.items) ? payload.items : []
        newState.activeCalls.totalActiveCalls = payload?.totalActiveCalls ?? 0
        newState.activeCalls.orgId = payload?.orgId ?? null
        break
      case SET_ACTIVE_CALLS_STATUS:
        newState.activeCalls.status = payload
        break
      default:
        break
    }
  })
}
